
export default {
  name: "branchbar",
  data() {
    return {
      showSearchModule: false,
      products: [],
      filterCount: 0,
      cities: [],
      districts: [],
      brands: [],
      brand: '',
      district: '',
      search_text: '',
    }
  },
  fetchKey: 'branchbar',
  created() {
    this.$nuxt.$on('changeBranch',(value) => {
      this[value.field] = value.value
      this.changeBranchOther()
    })

    this.$nuxt.$on('changeBranchCity',(value) => {
      this[value.field] = value.value
      this.changeBranchCity()
    })
  },
  computed: {
    city: {
      get() {
        return this.$store.state.city.slug
      },
      set(value) {
        this.$cookies.set('city', value, {
          sameSite: 'None'
        })
        localStorage.setItem("city", value)
        this.$store.commit('city/setCitySlug', value)
      }
    }
  },
  watch: {
    '$route.query': '$fetch'
  },
  async fetch() {
    this.cities =  []
    this.districts =  []
    this.brands = []
    if (this.city) {
      var districts = await this.$http.$get(`/regions/${this.city}/districts-by-slug`)
      if (districts.code === 1000) {
        districts.data.districts.forEach((district) => {
          this.districts.push({
            id: district.id,
            label: district.name,
            value: district.name,
            name: this.$nuxt.$helpers.upperCaseEach(district.name)
          })
        })
      }
    } else if (this.$route.query.city) {
      this.city = this.$route.query.city
      var districts = await this.$http.$get(`/regions/${this.$route.query.city}/districts-by-slug`)
      if (districts.code === 1000) {
        districts.data.districts.forEach((district) => {
          this.districts.push({
            id: district.id,
            label: district.name,
            value: district.name,
            name: this.$nuxt.$helpers.upperCaseEach(district.name)
          })
        })
      }
    }

    if (this.$route.query.brand) {
      this.brand = this.$route.query.brand
    }

    if (this.$route.query.district) {
      this.district = this.$route.query.district
    }
    if (this.$store.state.city.list.length > 0) {
      this.$store.state.city.list.forEach((city, key) => {
        if (city.slug !== '') {
          this.cities.push({
            id: city.id,
            label: city.name,
            value: city.slug,
            name: this.$nuxt.$helpers.upperCaseEach(city.name)
          })
        }
      })
    } else {
      var cities = await this.$http.$get('/regions/1/cities-with-products')
      if (cities.code === 1000) {
        cities.data.cities.forEach((city) => {
          this.cities.push({
            id: city.id,
            label: city.name,
            value: city.slug,
            name: this.$nuxt.$helpers.upperCaseEach(city.name)
          })
        })
        this.$store.commit('city/setCityList', this.cities)
      }
    }
    var brands = await this.$http.$get('/branch/groups')
    if (brands.code === 1000) {
      brands.data.branchGroups.forEach((brand) => {
        this.brands.push({
          id: brand.id,
          label: this.$nuxt.$helpers.upperCaseEach(brand.name),
          value: this.$helpers.slugify(brand.name),
          name: this.$nuxt.$helpers.upperCaseEach(brand.name)
        })
      })
    }
  },
  methods: {
    change() {
      var query = {}

      if (this.city) {
        query.city = this.city
      }

      if (this.brand) {
        query.brand = this.brand
      }

      if (this.district) {
        query.district = this.district
      }

      if (this.search_text) {
        query.search_text = this.search_text
      }

      if (query) {
        this.$router.push(this.localePath({
          name: 'branches',
          query: query
        }))
      } else {
        this.$router.push(this.localePath({
          name: 'branches',
        }))
      }
    },
    changeBranchCity() {
      this.districts =  []
      this.district = ''

      var query = {}
      if (this.brand) {
        query.brand = this.brand
      }

      if (this.city) {
        query.city = this.city
      }

      this.$route.params.search_text = ''
      this.search_text = ''

      if (query) {
        this.$router.push(this.localePath({
          name: 'branches',
          query: query
        }))
      } else {
        this.$router.push(this.localePath({
          name: 'branches',
        }))
      }
    },
    changeBranchOther() {
      var query = {}

      if (this.city) {
        query.city = this.city
      }

      if (this.brand) {
        query.brand = this.brand
      }

      if (this.district) {
        query.district = this.district
      }

      if (this.search_text) {
        query.search_text = this.search_text
      }

      if (query) {
        this.$router.push(this.localePath({
          name: 'branches',
          query: query
        }))
      } else {
        this.$router.push(this.localePath({
          name: 'branches',
        }))
      }
    },
  },
}
